import React, { useState } from "react";
import { AISearchDialog } from "@/components/AISearchDialog";

export const FloatingAI = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="floating-ai-fab"
        onClick={() => setOpen(true)}
        aria-label="Ask AI to find photos"
        className="relative w-12 h-12 rounded-full bg-primary shadow-lg shadow-primary/30 flex items-center justify-center hover:-translate-y-0.5 transition-transform ring-2 ring-primary/30"
      >
        <img src="/logo-icon.png" alt="BareFootage AI" className="w-7 h-7 object-contain" />
        <span className="absolute -top-1.5 -right-1.5 text-[8px] font-bold bg-background text-primary border border-primary/40 rounded-full px-1 py-0.5 leading-none">AI</span>
      </button>
      <AISearchDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
